import React from "react";
import { X } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
interface ErrorDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  errorMessage: string;
  title?: string;
}
const ErrorDialog = ({
  isOpen,
  onOpenChange,
  errorMessage,
  title = "Error"
}: ErrorDialogProps) => {
  return <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="text-white border-slate-700 bg-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-red-400">
            <div className="flex items-center text-red-500">
              <X className="h-5 w-5 mr-2" />
              {title}
            </div>
          </AlertDialogTitle>
          <AlertDialogDescription className="text-black">
            {errorMessage}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction className="bg-primary w-[100px] hover:bg-primary text-white">
            OK
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
};
export default ErrorDialog;